const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    level: {},
  },
  mutations: {
    setLevel (state, value) {
      state.level = value
    },
  },
  actions: {
    getLevel ({ commit }) {
      fb.db.collection("levels").doc(fb.firebase.auth().currentUser.uid).get().then((doc) => {
        if (doc.exists) {
          commit('setLevel', { id: doc.id,...doc.data() })
        } else {
          return console.log("No such document!");
        }
      })
    },
    async updateLevel ({ commit, state }, payload) {
      if (state.level[payload.field]) return
      let update = {}
      update[payload.field] = payload.value
      commit("setLevel", {...state.level, ...update})
      commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "Congratulations, you have just collected 1 🍀",
      },{ root: true });
      await fb.db
        .collection("levels")
        .doc(fb.firebase.auth().currentUser.uid)
        .update(update)
      
    },
  }
}
  